import { boxStyle, SerializedBadgeNode } from '../node/BadgeNode';
import { ParameterDto } from '@/Domain/api/Action/dto/Action.dto';

export const parseValueToEditor = (
  value: string,
  parameters: ParameterDto[],
): Array<string | SerializedBadgeNode> => {
  const parts: Array<string | SerializedBadgeNode> = [];
  const curlyRegex = /\{\{([^}]+)\}\}/;
  const squareRegex = /\[\[([^\]]+)\]\]/;
  const tokenRegex = new RegExp(`(${curlyRegex.source}|${squareRegex.source})`, 'g');

  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = tokenRegex.exec(value)) !== null) {
    const [full] = match;
    const curlyLabel = match[2]; // from curlyRegex inner group
    const squareLabel = match[3]; // from squareRegex inner group

    const isCurly = curlyLabel !== undefined;
    const label = isCurly ? curlyLabel : squareLabel;

    if (match.index > lastIndex) {
      parts.push(value.slice(lastIndex, match.index));
    }

    const matched = parameters?.find(
      (p) => p.name.replace(/ /g, '_').toLowerCase() === label.toLowerCase(),
    );

    parts.push({
      label,
      parameter_id: matched?.id ?? null,
      style: isCurly ? boxStyle.CURLY : boxStyle.SQUARE,
    } as SerializedBadgeNode);

    lastIndex = match.index + full.length;
  }

  if (lastIndex < value.length) {
    parts.push(value.slice(lastIndex));
  }

  return parts;
};
